import debounce from './vendor/just-debounce';
import verge from './vendor/verge';


import lazzyLoader from './lazzyLoader';
import util from './utils.js'; // {konsole, el_liveBind, el_trigger}
// import plyr from './vendor/plyr';
// import './vendor/smoothScroll';
import './vendor/swiper';
import ScrollDir from './vendor/scrolldir';
const konsole = util.konsole;

// const SmoothScroll = window.SmoothScroll;
const Swiper = window.Swiper;

class Site {
  constructor(pageSetup) {
    this.state = {
      scrollDir: 'neutral',
      stickyMenu: false,
      compactMenu: false
    };

    this.widget = {};

    this.el = {
      sections: [],
      menuItems: {
      },
      header: document.getElementById('part-header'),
      nav_spacer: document.getElementById('part-nav-spacer'),

      activeMenuItem: null,
      activeSection: null
    };

    this.events = {
      onResize: debounce(e => { this.onResize(); }, 50, false, true),
      onPageScroll: debounce(e => { this.onScroll(); }, 50, false, true)
    };

    pageSetup.menuItems.map(m => {
      const el_page = document.getElementById('sec_' + m.pid);
      if (!el_page) {
        console.log('elem #sec_' + m.pid + " is not found");
        return;
      }
      this.el.sections.push(el_page);
      this.el.menuItems[m.pid] = document.getElementById('menu_' + m.pid);
    });

    // this.scroll = new SmoothScroll('a[href*="#"]', {
    //   speed: 500,
    //   speedAsDuration: false,
    //   offset: (anchor, toggle) => {
    //     return this.el.header.offsetHeight;
    //   }
    // });

    this.scrollDir = new ScrollDir({
      onChange: dir => this.setState({scrollDir: dir})
    });


    this.el_playButtons = document.querySelectorAll('.m-works-swiper__play-button');

    this.el_videos = document.querySelectorAll('.m-works-swiper__video');

    this.el_works_close_button = document.getElementById('works_close_button');

    this.el_works_grid = document.getElementById('works_grid');

    this.el_works_grid_items = document.querySelectorAll('.m-works-grid__item');

    this.el_swiper_overlay_wrapper = document.getElementById('swiper_overlay_wrapper');

    this.el_works_dynamic_content_inner = document.getElementById('works_dynamic_content_inner');

    this.el_mobile_work_swipers = document.querySelectorAll('.mobile-swiper');

    this.el_swiper_playtoggle_budapest = document.querySelector('.swiper-playtoggle-budapest');

    this.el_accordion_buttons = document.querySelectorAll(".mobile-swiper-text--button");

    this.el_newsletter_form = document.getElementById('newsletter-signup-form');
    this.el_newsletter_form_name = document.getElementById('newsletter_name');
    this.el_newsletter_form_email = document.getElementById('newsletter_email');
    this.el_newsletter_form_terms = document.getElementById('newsletter_terms');
    this.el_newsletter_success = document.getElementById('newsletter_success');
    this.el_newsletter_error = document.getElementById('newsletter_error');
    this.el_newsletter_fields = document.getElementById('newsletter_fields');


    // this.el_plyrPlayers = Plyr.setup('.m-works-swiper__video');

    this.createDynamicStyleSheet();
    this.bindEvents();
    this.applyLazzyLoad();
    this.initWidgets();
    this.onScroll();
  }

  createDynamicStyleSheet() {
    const style = document.createElement('style');
    style.type = 'text/css';
    style.id = 'dynamic-styles';
    document.head.appendChild(style);
    this.dynamicStyleSheet = style.sheet;
  }

  /**
   * Updates or creates a CSS rule in the dynamic stylesheet.
   * @param {string} selector - The CSS selector for the rule.
   * @param {string} cssText - The CSS text to apply to the rule.
   * @return {void}
   * @example
   * updateCssRule('.my-class', 'color: red; background-color: blue;');
   */
  updateCssRule(selector, cssText) {
    const sheet = this.dynamicStyleSheet;
    let ruleIndex = -1;
    for (let i = 0; i < sheet.cssRules.length; i++) {
      if (sheet.cssRules[i].selectorText === selector) {
        ruleIndex = i;
        break;
      }
    }
    if (ruleIndex !== -1) {
      sheet.deleteRule(ruleIndex);
    }
    sheet.insertRule(`${selector} { ${cssText} }`, sheet.cssRules.length);
  }

  setState(state) {
    const oldState = this.state;
    this.state = {...this.state, ...(state || {})};
    this.update(this.state, oldState);
  }

  update(state, oldState) {
    if (state.scrollDir !== oldState.scrollDir) {
      document.body.classList.toggle('scroll-up', state.scrollDir === 'up');
      document.body.classList.toggle('scroll-down', state.scrollDir === 'down');
    }
    if (state.stickyMenu !== oldState.stickyMenu) {
      document.body.classList.toggle('sticky-menu', state.stickyMenu);
    }
  }
  onScrollImmediately() {
    if (window.scrollY < 1) {
      if (this.state.stickyMenu) { this.setState({stickyMenu: false}); }
    }
    else {
      if (!this.state.stickyMenu) { this.setState({stickyMenu: true}); }
    }
  }
  onResize() {
    this.el.nav_spacer.style.height = this.el.header.offsetHeight + 'px';
    this.updateCssRule(':root', `--header-height: ${this.el.header.offsetHeight}px;`);
  }
  onScroll() {

    let el_inView = null;
    let inViewport = [];

    this.el.sections.forEach(el => {
      if (el.offsetWidth && verge.inViewport(el, -200)) {
        inViewport.push(el);
      };
    });


    if (window.scrollY < 50) {
      el_inView = inViewport[0] || this.el.sections[0];
    }
    else {
      el_inView = inViewport.length ? inViewport[inViewport.length - 1] : (
        this.state.activeSection || this.el.sections[0]
      );
    }
    if (el_inView) {
      this.state.activeSection = el_inView;
    }

    const id = el_inView.getAttribute('id').replace('sec_', '');

    if (this.el.activeMenuItem === this.el.menuItems[id]) {
      return;
    }
    let activeMenuHasFocus = false;
    if (this.el.activeMenuItem) {
      activeMenuHasFocus = this.el.activeMenuItem === document.activeElement;
      this.el.activeMenuItem.classList.remove("m-main-navigation__link--active");
    }
    this.el.activeMenuItem = this.el.menuItems[id];
    this.el.activeMenuItem.classList.add("m-main-navigation__link--active");
    if (activeMenuHasFocus) {
      this.el.activeMenuItem.focus();
    }
  }

  bindEvents() {
    window.addEventListener('scroll', e => {
      this.events.onPageScroll(e);
      this.onScrollImmediately(e);
    });

    window.addEventListener('resize', e => {
      this.events.onResize(e);
    });

    this.onScroll();
    this.onResize();

    const el_main_nav = document.querySelector('.m-main-navigation__list');
    document.getElementById('close_button').addEventListener('click', function() {
      el_main_nav.classList.toggle('m-main-navigation__list--opened');
    });

    for (const pid in this.el.menuItems) {
      if (this.el.menuItems.hasOwnProperty(pid) && this.el.menuItems[pid]) {
        this.el.menuItems[pid].addEventListener('click', function() {
          el_main_nav.classList.remove('m-main-navigation__list--opened');
          util.el_trigger(window, 'scroll');
        });
        this.el.menuItems[pid].addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            el_main_nav.classList.remove('m-main-navigation__list--opened');
            util.el_trigger(window, 'scroll');
          }
        });
      }
    }


    this.el_playButtons.forEach(function(el_playButton) {
      el_playButton.addEventListener('click', function() {
        const el_videoPlayer = this.nextElementSibling;
        const playerMethod = el_videoPlayer.paused ? 'play' : 'pause';
        el_videoPlayer[playerMethod]();
        // this.classList.add('m-works-swiper__play-button--hidden');
      });
    });

    this.el_accordion_buttons.forEach((el_button) => {

      let el_buttons = this.el_accordion_buttons;

      function closeAll() {
        for (let i = 0; i < el_buttons.length; i++) {
          el_buttons[i].classList.remove("active");
          el_buttons[i].nextElementSibling.style.maxHeight = null;
        }
      }

      function openAll() {
        for (let i = 0; i < el_buttons.length; i++) {
          el_buttons[i].classList.add("active");
          // eslint-disable-next-line indent
          el_buttons[i].nextElementSibling.style.maxHeight = el_buttons[i].nextElementSibling.scrollHeight + "px";
        }
      }

      el_button.addEventListener('click', function() {

        if (!this.classList.contains('active')) {
          closeAll();
        }

        this.classList.toggle("active");
        var el_accordion = this.nextElementSibling;

        if (el_accordion.style.maxHeight) {
          el_accordion.style.maxHeight = null;
        }
        else {
          el_accordion.style.maxHeight = el_accordion.scrollHeight + "px";
        }
      });
    });


    this.bindWorks();
    if (this.el_newsletter_form) {
      this.bindForm();
    }
  }

  bindWorks() {
    let e_show_btn = e => {
      e.target.parentNode.querySelector('.m-works-swiper__play-button')
        .classList.remove('m-works-swiper__play-button--hidden');
    };

    let e_hide_btn = e => {
      e.target.parentNode.querySelector('.m-works-swiper__play-button')
        .classList.add('m-works-swiper__play-button--hidden');
    };

    this.el_videos.forEach(function(el_video) {
      el_video.addEventListener('play', e_hide_btn, true);
      el_video.addEventListener('pause', e_show_btn, true);
      el_video.addEventListener('ended', e_show_btn, true);
    });

    const closeSlider = () => {
      document.getElementById('swiper_overlay').classList.toggle("l-overlay--active");
      this.widget.worksSwiper.removeAllSlides();
    }

    this.el_works_close_button.addEventListener('click', closeSlider);

    // close swipper on escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && document.getElementById('swiper_overlay').classList.contains("l-overlay--active")) {
        closeSlider();
      }
    });


    this.el_swiper_playtoggle_budapest.addEventListener('click', () => {
      if (this.widget.budapestSwiper.autoplay.running) {
        this.widget.budapestSwiper.autoplay.stop();
        this.el_swiper_playtoggle_budapest.classList.add('swiper-playtoggle-budapest--play');
      }
      else {
        this.widget.budapestSwiper.autoplay.start();
        this.el_swiper_playtoggle_budapest.classList.remove('swiper-playtoggle-budapest--play');
      }
    });

    this.el_works_grid_items.forEach((el_works_grid_item, index) => {
      let item_index = index;
      el_works_grid_item.addEventListener('click', () => {
        let obj_work = window._pageSetup.worksItems[item_index];

        for (let i = 0; i <= obj_work.numberOfImages; i++) {
          if (!obj_work || !obj_work.images || !obj_work.images[i]) {
            return;
          }
          let str_slide_single_image =
          `<div class="swiper-slide">
            <div class="m-works-swiper__video-slide-inner">
              <img src="${obj_work.images[i].folder_qip}" data-src="${obj_work.images[i].folder_img}" class="swiper-lazy m-works-swiper__image" alt="${obj_work.title}">
              <div class="swiper-lazy-preloader swiper-lazy-preloader"></div>
            </div>
          </div>`;
          this.widget.worksSwiper.appendSlide(str_slide_single_image);
        }

        this.el_works_dynamic_content_inner.innerHTML =
        `
          <h1 class="m-large-heading m-large-heading--no-bottom-margin  align-left">${obj_work.title}</h1>
          <p class="m-sub-heading m-sub-heading--blue">${obj_work.subtitle}</p>
          <p class="m-body-text m-body-text--margin-bottom m-body-text--left-align"><strong>${obj_work.highlight}</strong></p>
          <br>
          <p class="m-body-text m-body-text--margin-bottom m-body-text--left-align">${obj_work.body}</p>
          `;

        document.getElementById('swiper_overlay').classList.add("l-overlay--active");

        this.initWidgets();
      });
    });
  }

  postData(url = '/', data = {}, success, error) {
    window.axios.post(url, {...data}
    ).then((response) => {
      if (typeof success === "function") {
        success(response);
      }
    }).catch((err) => {
      if (typeof error === "function") {
        error(err);
      }
      if (window.console) {
        console.error(err);
      }
    });
  }

  bindForm() {
    // axios
    this.el_newsletter_form.addEventListener('submit', e => {
      e.preventDefault();

      this.postData('/newsletter/index.php', {
        name: this.el_newsletter_form_name.value.trim(),
        email: this.el_newsletter_form_email.value.trim(),
        terms: this.el_newsletter_form_terms.checked
      }, ({data, status}) => {
        // console.log(data, data.error);

        if (data.error) {
          this.el_newsletter_error.querySelector('.value').innerHTML = data.error_msg;
        }
        this.el_newsletter_fields.classList.toggle('hidden', !data.error);
        this.el_newsletter_success.classList.toggle('hidden', data.error);
        this.el_newsletter_error.classList.toggle('hidden', !data.error);
      });
    });
  }

  applyLazzyLoad() {
    lazzyLoader.init();
    document.querySelectorAll('.lazzy-qip-unloaded').forEach(el => {
      lazzyLoader.add('image', el, el.getAttribute('data-src'), 'lazzy-qip-unloaded', false);
    });
    document.querySelectorAll('.lazzy-qip-bg-unloaded').forEach(el => {
      lazzyLoader.add('background', el, el.getAttribute('data-src'), 'lazzy-qip-bg-unloaded', false);
    });
  }

  initWidgets() {

    this.el_mobile_work_swipers.forEach((item, index) => {
      this.widget["mobileSwiper_" + index] = new Swiper(`#mobile-swiper-container-${index}`, {
        speed: 400,
        lazy: true,
        // disableOnInteraction: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    });

    this.widget.worksSwiper = new Swiper('.m-works-swiper__main', {
      spaceBetween: 600,
      loop: false,
      preventInteractionOnTransition: true,
      preventClicks: true,
      slideToClickedSlide: true,
      allowTouchMove: false,
      preloadImages: false,
      lazy: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      breakpoints: {
        1080: {
          allowTouchMove: true
        }
      },
      on: {
        slideChange: function() {
          document.querySelectorAll('.m-works-swiper__video').forEach(el => {
            if (el.playing || !el.paused) {
              el.pause();
              if (el.currentTime > 0) {
                el.currentTime = 0;
                el.load();
              }
              el.autoplay = false;
            }
          });

          document.querySelectorAll('.m-works-swiper__play-button').forEach(el => {
            el.classList.remove('m-works-swiper__play-button--hidden');
          });
        }
      }
    });

    this.widget.brandsSwiper = new Swiper('.m-brands-swiper__inner', {
      allowTouchMove: false,
      preloadImages: false,
      lazy: true,
      breakpoints: {
        1080: {
          allowTouchMove: false
        }
      }
    });

    this.widget.budapestSwiper = new Swiper('.swiper-container-budapest', {
      centeredSlides: true,
      preloadImages: false,
      lazy: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });


  }
}

export default Site;
